// @ts-nocheck
import React from 'react';
import icons from '../../../../constants/icons';
import ImageFromApi from '../../../common/ImageFromApi';

export interface KeyProviderRowProps {
  game: any;
  style: React.CSSProperties;
  keyProviders: any[];
}

function KeyProviderRow({ game, style, keyProviders }: KeyProviderRowProps) {
  let keyProvider = keyProviders.find(
    (keyProvider) => keyProvider.id === game.keyProviderId
  );
  return (
    <div className="grid-empty" style={style}>
      {game.isSKU && (
        <>
          <ImageFromApi
            imageId={keyProvider.imageId}
            fallbackIcon={icons.KEY_PROVIDER}
            colourHex={keyProvider.colourHex}
          ></ImageFromApi>
          {keyProvider.name}
        </>
      )}
    </div>
  );
}

export default KeyProviderRow;
